module.exports = __webpack_public_path__ + "static/media/cushman_wakefield.d3f87543.png";